import { createFileRoute } from '@tanstack/react-router';
import LoadingPage from '../../../components/shared/page-components/LoadingPage';
import { ValidatorProvider } from '../../../components/staking/providers/ValidatorProvider';
import ValidatorDetail from '../../../components/staking/ValidatorDetail';

function ValidatorDetailPage() {
  return (
    <ValidatorProvider>
      <ValidatorDetail />
    </ValidatorProvider>
  );
}

export const Route = createFileRoute('/_authenticated/staking/$validatorId')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ValidatorDetailPage,
  staticData: {
    configPageId: 'staking',
    meta: {
      title: 'Validator Details | Ledgible',
    },
  },
});
